import { render, staticRenderFns } from "./InstanceUserRoleDialog.vue?vue&type=template&id=0847ca72&scoped=true&"
import script from "./InstanceUserRoleDialog.vue?vue&type=script&lang=js&"
export * from "./InstanceUserRoleDialog.vue?vue&type=script&lang=js&"
import style0 from "./InstanceUserRoleDialog.vue?vue&type=style&index=0&id=0847ca72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0847ca72",
  null
  
)

export default component.exports